module.exports = __webpack_public_path__ + "img/soundcat_app_new_main.c7afa2c7.png";